import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    octMaia: false,
    fullETDRS: false,
    tmmETDRS: false,
    squareGrid: false,
    degCircle: false,
    selectedEye: '',
    gridName: ''
  };
  

  export const annotationSlice = createSlice({
    name: 'annotations',
    initialState,
    reducers: {
      setData: (state, action) => {
        state[action.payload.name] = action.payload.checked;
      },
      setDataState: (state, action) => {
        for (let key in action.payload) {
          state[key] = action.payload[key];
        }
      }
    },
  });
  
  export const { setData, setDataState } = annotationSlice.actions;
  
  export const selectSelectedGrid = (state, gridName) => state.annotations[gridName];
  export const selectSelectedEye = (state) => state.annotations.selectedEye;
  
  export default annotationSlice.reducer;
  
